import { render, staticRenderFns } from "./TaxLayout.vue?vue&type=template&id=5745a27c&scoped=true&"
import script from "./TaxLayout.vue?vue&type=script&lang=js&"
export * from "./TaxLayout.vue?vue&type=script&lang=js&"
import style0 from "./TaxLayout.vue?vue&type=style&index=0&id=5745a27c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5745a27c",
  null
  
)

export default component.exports